import { render } from "./RuiSpinner.vue?vue&type=template&id=045f3b56&scoped=true"
import script from "./RuiSpinner.vue?vue&type=script&lang=ts"
export * from "./RuiSpinner.vue?vue&type=script&lang=ts"

import "./RuiSpinner.vue?vue&type=style&index=0&id=045f3b56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-045f3b56"

export default script